/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbox_Na_Team_AnswerInputs */

const en_inbox_na_team_answer = /** @type {(inputs: Inbox_Na_Team_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The team needs you`)
};

const id_inbox_na_team_answer = /** @type {(inputs: Inbox_Na_Team_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim perlu kamu`)
};

/**
* | output |
* | --- |
* | "The team needs you" |
*
* @param {Inbox_Na_Team_AnswerInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const inbox_na_team_answer = /** @type {((inputs?: Inbox_Na_Team_AnswerInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbox_Na_Team_AnswerInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_inbox_na_team_answer(inputs)
	return en_inbox_na_team_answer(inputs)
});